import React from 'react'
import { COMPANY_LOGO } from '../../constants'

interface CommonHeadProps {
  title?: string | null
  description?: string | null
  children?: React.ReactNode
  url: string
  image?: string | null
  type?: 'website' | 'article'
}

// todo: Move to contexts/seo/constants
export const DEFAULT_TITLE = 'Qwick | Hospitality Staffing + Gig Platform'
export const DEFAULT_DESCRIPTION =
  "The Qwick platform connects you to the hospitality industry; whether you're looking for shifts, or trying to staff them. Sign up today."
const DEFAULT_CLOUDINARY_URL = 'https://res.cloudinary.com/gigpro/image/upload/'

export const CommonHead: React.FunctionComponent<CommonHeadProps> = ({
  title: titleOverride,
  description: descriptionOverride,
  url,
  children,
  image: imageOverride,
  type = 'website',
}) => {
  if (imageOverride?.startsWith('profiles')) {
    imageOverride = `${DEFAULT_CLOUDINARY_URL}${imageOverride}`
  }
  const title = titleOverride || DEFAULT_TITLE
  const image = imageOverride || COMPANY_LOGO
  const description = descriptionOverride || DEFAULT_DESCRIPTION
  return (
    <>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {children}
    </>
  )
}
